import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import { PlusIcon } from 'images/common'
import DropdownContainer from '../DropdownContainer/DropdownContainer'

const TagAdd = ({ placeholder = 'Create', tag, tags, suggestions, setTag, updateTags, color, autocomplete, dropUp, dropPosition = 'left', isDropDown }) => {
  const [showPlusIcon, setShowPlusIcon] = useState(true)
  const [inputPlaceholder, setInputPlaceholder] = useState(placeholder)
  const [tagsFound, setTagsFound] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)
  const [fakeWidth, setFakeWidth] = useState(0)
  const textInput = useRef(null)
  const dropdownRef = useRef(null)
  const inputSize = tag.length - 1 > placeholder.length ? tag.length : placeholder.length
  const removeUsedTags = autocomplete.filter(tag => !tags.some(t => t.toLowerCase() === tag.toLowerCase()))
  const isTagSelected = tags.some(t => t.toLowerCase() === tag.toLowerCase())
  const isTagAvailable = !isDropDown && removeUsedTags.some(t => t.toLowerCase() === tag.toLowerCase())

  const inputClass = classNames(
    'viso-tag-add__input',
    !showPlusIcon && `viso-tag-add__input--focused viso-border-${color}`
  )

  const setFakeRef = (node) => {
    if (node !== null) {
      setFakeWidth(node.offsetWidth)
    }
  }

  const onUpdateTags = (selectedTags, persistDropdown) => {
    const upateTagsFound = autocomplete.filter(item => !selectedTags.includes(item))
    updateTags(selectedTags)
    setTag('')
    setShowDropdown(persistDropdown)
    setTagsFound(upateTagsFound)
    setShowPlusIcon(true)
    setInputPlaceholder(placeholder || 'Create')
    textInput.current.value = ''
  }

  const addTagsOnEnter = (e) => {
    if (e.key === 'Enter' && tag && !isDuplicateTag(tag)) {
      e.stopPropagation()
      e.preventDefault()
      handleTagUpdate(tag, true)
    }
  }

  const handleTagUpdate = (tag, persistDropdown) => {
    if (isTagAvailable) {
      const findTag = autocomplete.find(t => t.toLowerCase() === tag.toLowerCase())
      const selectedTags = [...tags, findTag]
      onUpdateTags(selectedTags, persistDropdown)
    } else if (!isTagSelected) {
      const selectedTags = [...tags, tag]
      onUpdateTags(selectedTags, persistDropdown)
    }
  }

  const onSuggestionClick = (value) => {
    handleTagUpdate(value)
  }

  const addTag = () => {
    if (tag && !(isTagSelected || isDuplicateTag(tag))) {
      handleTagUpdate(tag)
    }
  }

  const onFocus = () => {
    if (!isDropDown) {
      setShowPlusIcon(false)
      setInputPlaceholder('')
    }
    setTagsFound(removeUsedTags)
    setShowDropdown(true)
  }

  const onBlur = (e) => {
    if (dropdownRef.current && dropdownRef.current.contains(e.relatedTarget)) {
      return
    }

    if (tag && !(isTagSelected || isDuplicateTag(tag))) {
      handleTagUpdate(tag)
    } else {
      setShowDropdown(false)
      setInputPlaceholder(placeholder || 'Create')
      setShowPlusIcon(true)
    }
  }

  const onInputChange = (value) => {
    const findTags = removeUsedTags.filter(tag => tag.toLowerCase().includes(value.toLowerCase()))
    setTagsFound(findTags)
    setTag(value)
  }

  const isDuplicateTag = (value) => {
    const normalized = value.trim().toLowerCase()
    const isTagInTags = tags.some(t => t.toLowerCase().trim() === normalized)
    const isTagInSuggestions = suggestions.some(t => t.toLowerCase().trim() === normalized)
    const isTagInAutocomplete = autocomplete.some(t => t.toLowerCase().trim() === normalized)
    return isTagInTags || isTagInSuggestions || isTagInAutocomplete
  }

  return (
    <div className='viso-tag-add'>
      <span className='viso-tag-add__fake' ref={setFakeRef}>
        {placeholder}
      </span>
      <input
        type='text'
        placeholder={inputPlaceholder}
        className={inputClass}
        onChange={(e) => onInputChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={addTagsOnEnter}
        ref={textInput}
        size={showPlusIcon ? 1 : inputSize}
        style={{ minWidth: fakeWidth + 42 }}
        readOnly={isDropDown}
      />
      {showPlusIcon &&
        <span
          onClick={addTag}
          className='viso-tag-add__plus'
        >
          <PlusIcon />
        </span>
      }
      {showDropdown &&
        <div ref={dropdownRef}>
          <DropdownContainer
            list={!isDropDown && tagsFound}
            actions={isDropDown && autocomplete}
            showDropdown={showDropdown}
            setShowDropdown={setShowDropdown}
            position={dropPosition}
            emptyMessage='No matching tags found'
            listClick={onSuggestionClick}
            dropUp={dropUp}
          />
        </div>
      }
    </div>
  )
}

export default TagAdd